import type { TFunction } from 'i18next';
import { LOGIN_TYPES, type LoginType } from './constants';

export const useLoginState = (condition: LoginType | string, t: TFunction): [string, string] => {
  switch (condition) {
    case LOGIN_TYPES.WELCOME:
      return [t('translation:login.popup_labels.login_welcome'), t('translation:login.popup_body.login_welcome')];
    case LOGIN_TYPES.ERROR_EMAIL:
      return [
        t('translation:login.popup_labels.login_email_error'),
        t('translation:login.popup_body.login_email_error'),
      ];
    case LOGIN_TYPES.APP_CRASH:
      return [t('translation:login.popup_labels.login_email_error'), t('translation:login.popup_body.critical_error')];
    case LOGIN_TYPES.ERROR:
    default:
      return [t('translation:login.popup_labels.login_error'), t('translation:login.popup_body.login_error')];
  }
};
